export const serviceOrderGroupsMock = [
  {
    serviceOrderGroupId: 'group-1',
    type: 'CUSTOM',
    name: 'Group 1',
    isActive: true,
    validityFrom: null,
    validityTo: null,
  },
  {
    serviceOrderGroupId: 'group-2',
    type: 'SYSTEM',
    name: 'Group 2',
    isActive: true,
    validityFrom: null,
    validityTo: null,
  },
];
